<!--
 * @Author: liuYingBing
 * @Date: 2024-02-06 16:25:38
 * @LastEditors: liuYingBing
 * @LastEditTime: 2024-12-19 14:37:32
 * @FilePath: /fushigi/src/App.vue
 * @Description:
-->
<script setup lang="ts">
// import { useSpinStore } from '@/store'
// import { Spin } from 'ant-design-vue'
import zhCN from 'ant-design-vue/lib/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import HeaderNotify from '@/components/HeaderNotify.vue'
import { RouterView } from 'vue-router'

dayjs.locale('zh-cn')
// const SpinStore = useSpinStore()
</script>

<template>
  <Suspense>
    <template #default>
      <a-config-provider
        :locale="zhCN"
        :theme="{
          token: {
            colorPrimary: '#7828FF',
            colorLink: '#7828FF',
            colorLinkHover: '#7828FF',
            borderRadiusBase: '8px',
            borderColorBase: '#D6D6D6',
          },
        }"
      >
        <!-- <Spin wrapper-class-name="u-spin" :spinning="SpinStore.loading"> -->
        <HeaderNotify />
        <RouterView />
        <!-- </Spin> -->
      </a-config-provider>
    </template>
    <template #fallback><Spin /></template>
  </Suspense>
</template>

<style lang="less">
html {
  font-size: 20px;
}

body {
  margin: 0;
}

.ant-spin-container {
  overflow: hidden;
}

.u-spin .ant-spin-container::after {
  background: transparent;
}

.u-spin .ant-spin-blur {
  opacity: 1;
}

.ant-spin-nested-loading {
  z-index: 99;
}
.ant-spin-nested-loading.u-spin {
  > div > .ant-spin {
    transform: translateY(-50%);
    top: 50%;
  }
}

.u-dark {
  th::before {
    display: none;
    background-color: transparent !important;
  }

  .ant-table-thead > tr > th,
  .ant-table-placeholder > td {
    border-bottom: 0 !important;
  }
  tr > td {
    border-color: #5a5a5a !important;
  }

  .ant-table,
  .ant-table td,
  colgroup:hover,
  .ant-table-header:hover,
  // thead:hover,
  // th:hover,
  .ant-table-header tr:hover,
  tr > td:hover {
    background-color: transparent !important;
  }

  .ant-table a {
    color: @primary-color!important;
  }

  .ant-table th {
    background-color: rgba(255, 255, 255, 0.04) !important;
    color: #7d7d7d !important;
  }

  ::-webkit-scrollbar-track,
  ::-webkit-scrollbar-thumb {
    background: transparent !important;
  }

  ::-webkit-scrollbar-thumb {
    background: #7d7d7d !important;
  }

  .ant-checkbox-inner {
    background-color: transparent;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: @primary-color;
  }

  .ant-checkbox-wrapper-disabled {
    .ant-checkbox-inner {
      background-color: transparent;
    }
    .ant-checkbox-disabled + span {
      color: #434343 !important;
    }

    .ant-checkbox-disabled .ant-checkbox-inner:after {
      border-color: #434343 !important;
    }
  }

  .ant-tabs-tab-btn,
  .ant-tabs .ant-tabs-tab-btn:active {
    color: rgb(172, 172, 172);
  }

  .ant-drawer-title {
    color: #dbdbdb;
  }

  .ant-table .ant-empty-image {
    display: none;
  }

  .ant-table .ant-empty-description {
    color: #5a5a5a;
  }
  .ant-table-cell-scrollbar {
    display: none !important;
  }

  .ant-table-row .ant-table-cell {
    color: #bdbdbd !important;
  }
}

.ant-modal-mask {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
.pagination {
  // 改变页码按钮的默认文字颜色
  .ant-pagination-item a {
    color: #acacac; // 白色文字
  }

  // 改变当前页码按钮的文字颜色和背景颜色
  .ant-pagination-item-active {
    background-color: @primary-color; // 蓝色背景
    border-color: @primary-color; // 蓝色边框
    a {
      color: #fff !important; // 白色文字
    }
  }

  // 新增：改变当前活动页码链接的颜色
  .ant-pagination-item-active .ant-pagination-item-link {
    color: #ffffff; // 当前活动页码链接的文字颜色改为白色
  }
}
// 改变禁用状态页码按钮的文字颜色
.ant-pagination-disabled button,
.ant-pagination-disabled a {
  color: #acacac; // 浅白色文字
}
.ant-pagination .ant-pagination-prev .ant-pagination-item-link {
  color: #acacac !important;
}
.ant-pagination .ant-pagination-next .ant-pagination-item-link {
  color: #acacac !important;
}
.ant-pagination .ant-pagination-jump-prev .ant-pagination-item-link {
  color: #acacac !important;
}
</style>
